<template>
  <div class="home-news">
    <header class="home-news-hd">
      <div
        class="news-hd-wrapper"
        v-scroll-animate="{
          animation: 'fadeInDown',
        }"
      >
        <h4 class="news-hd-subTitle">News</h4>
        <h2 class="news-hd-title">
          Get to know the latest news and activities of Delauney
        </h2>
      </div>
    </header>
    <div class="classification">
      <div class="tabs">
        <div class="tabs-content">
          <el-tabs v-model="classification">
            <el-tab-pane
              :label="item.name"
              :name="item.value"
              v-for="item in tabList"
              :key="item.value"
            >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <template v-if="newsList.length == 0">
      <EmptyPage :name="'No data available at the moment!'" />
    </template>
    <template v-else>
      <div class="newsList">
        <div
          v-for="(item, index) in newsList"
          :key="index"
          class="newsCard"
          @click="openUrl(item)"
        >
          <div style="color: #bbbbbb; text-align: right">
            <div style="font-size: 24px; margin-top: 16px">
              <!-- $uniFun.formatDateSimple(news.date) -->
              {{ item.publishDate.split("-").slice(1).join("-") }}
            </div>
            <br />
            <div style="font-size: 14px; margin-top: 8px">
              {{ item.publishDate.split("-")[0] }}
            </div>
          </div>

          <div class="line"></div>

          <div class="text">
            <div class="title">{{ item.title }}</div>

            <div class="summary">{{ item.summary }}</div>
          </div>

          <img class="thumbnail" :src="item.picUrl" alt="轮播图" />
        </div>
      </div>

      <div style="margin: 0 auto; padding-bottom: 80px; width: fit-content">
        <Pagination
          layout="prev, pager, next"
          :isPadding="true"
          :page.sync="queryInfo.pageNum"
          :limit.sync="queryInfo.pageSize"
          :total="total"
          @pagination="handleSizeChange"
        ></Pagination>
      </div>
    </template>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import EmptyPage from "@/components/EmptyPage.vue";

import { infoManageApi } from "@/api/website";
export default {
  name: "newsIndex",
  props: {},
  components: {
    EmptyPage,
    Pagination,
  },
  data() {
    return {
      total: 120,
      classification: "1",
      tabList: [
        {
          name: "ALL",
          value: "0",
        },
        {
          name: "News",
          value: "1",
        },
        {
          name: "Video",
          value: "2",
        },
      ],
      newsList: [],
      queryInfo: {
        pageSize: 5,
        pageNum: 1,
      },
    };
  },
  computed: {},
  watch: {
    classification(newV) {
      // let page = this.$route.query.page;
      // if (page) this.queryInfo.pageNum = Number(page);
      this.queryInfo.pageNum = 1;
      this.getNewsList();
    },
  },
  created() {},
  mounted() {
    let classification = this.$route.query.classification;
    if (classification) this.classification = classification;
    let page = this.$route.query.page;
    if (page) this.queryInfo.pageNum = Number(page);

    this.getNewsList();
  },
  methods: {
    getNewsList() {
      let params = {
        current: this.queryInfo.pageNum,
        size: this.queryInfo.pageSize,
        type: this.classification === "0" ? undefined : this.classification,
      };
      infoManageApi(params).then((res) => {
        if (res.code === 200 && res.success) {
          let nowTimeString = this.$uniFun.getNowTime();
          let temp = res.data.records.filter(
            (item) =>
              nowTimeString > item.effectiveTime && item.startupStatus === "2",
          ); // 查找出已启用且生效的数据
          this.newsList = temp.map((item) => {
            return {
              id: item.id,
              picUrl:
                item.coverUrlIdList.length > 0
                  ? item.coverUrlIdList[0].path
                  : "",
              linkUrl: "",
              title: item.title,
              publishDate: item.effectiveTime.split(" ")[0],
              summary: item.subtitle,
            };
          });
          this.total = res.data.total;
        }
      });
    },
    handleSizeChange(e) {
      this.queryInfo.pageNum = e.pageIndex;
      this.getNewsList();
    },
    openUrl(item) {
      this.$uniFun.openInCurrentTab(
        // item.linkUrl + `?id=` + item.id + `&page=` + this.queryInfo.pageNum
        `/pc_index/newsDetail?&id=${item.id}&classification=${this.classification}&page=${this.queryInfo.pageNum}`,
      );
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.home-news {
  background: white;
  .home-news-hd {
    width: 100%;
    height: 200px;
    background: url("~@/views/web/home/imgs/newsBanner.png") no-repeat center;
    background-size: cover;
    .news-hd-wrapper {
      width: 1200px;
      margin: 0 auto;
      padding-top: 50px;
      .news-hd-subTitle {
        margin-bottom: 20px;
        font-weight: 400;
        font-size: 18px;
        color: #fff;
        line-height: 27px;
        font-style: normal;
      }
      .news-hd-title {
        font-weight: bold;
        font-size: 28px;
        color: #fff;
        line-height: 28px;
        font-style: normal;
      }
    }
  }
}

.selected {
  width: fit-content;
  height: 64px;
  font-weight: bold;
  font-size: 18px;
  color: #1d1d1f;
  line-height: 64px;
  text-align: center;
  font-style: normal;
  border-bottom: 2px solid #0035fb;
  cursor: pointer;
}
.normal {
  width: fit-content;
  height: 64px;
  font-weight: 400;
  font-size: 18px;
  color: #1d1d1f;
  line-height: 64px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}

.newsList {
  width: fit-content;
  margin: 0 auto;
  height: fit-content;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 40px 0;

  .newsCard {
    width: 100%;
    height: 185px;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    gap: 24px;
    cursor: pointer;

    .line {
      width: 39px;
      height: 1px;
      background: #eeeeee;
      margin-top: 28px;
    }

    .text {
      padding: 16px 0;
      .title {
        margin-bottom: 4px;
        @extend .text-truncate-multiline;
        --line-clamp: 2;
        width: 744px;
        height: 48px;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }

      .summary {
        width: 744px;
        height: auto;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 24px;
        text-align: left;
        font-style: normal;
      }
    }

    .thumbnail {
      width: 280px;
      height: 160px;
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      .thumbnail {
        transform: scale(1.05);
      }
      .title {
        color: #0035fb;
      }
    }
  }
}
</style>
<style lang="scss">
.classification {
  position: sticky;
  left: 0;
  top: 80px;
  padding-left: calc(50% - 600px);
  width: 100%;
  height: 64px;
  margin: 0 auto;
  border-bottom: 1px solid #d8d8d8;
  display: flex;
  gap: 40px;
  background: #fff;
  .tabs {
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #d8d8d8;
    .el-tabs__nav-wrap::after {
      display: none !important;
    }
    .el-tabs__item {
      color: #1d1d1f !important;
      font-size: 18px !important;
      opacity: 0.8;
    }
    .el-tabs__item.is-active {
      color: #1d1d1f !important;
      font-weight: bold !important;
      opacity: 1;
    }
    .el-tabs__item:hover {
      color: #1d1d1f !important;
      opacity: 1;
    }
    .el-tabs__active-bar {
      background-color: #0035fb !important;
    }
    .tabs-content {
      padding: 0;
      width: 1200px;
      margin: 0 auto;
      box-sizing: border-box;
    }
  }
}
</style>
